<label
    class="ap-progress {{ typeClassName }}"
    [class.ap-progress--small]="small()"
    [attr.data-percentage]="percentage"
    [style.--percentage]="percentage"
>
    @if (label()) {
        <span class="ap-progress__label" data-testid="label">{{ label() }}</span>
    }
    <progress class="ap-progress__bar" [attr.value]="progress()" [attr.max]="max()" data-testid="progress">{{ percentage }} %</progress>
</label>
